import React from 'react';
import Link from '@xem/look/Link';
import Row from '@gqlapp/base/Row';
import Col from '@gqlapp/base/Col';
import Card from 'reactstrap/lib/Card';
import CardGroup from 'reactstrap/lib/CardGroup';
import CardText from 'reactstrap/lib/CardText';
import CardTitle from 'reactstrap/lib/CardTitle';
import CardBody from 'reactstrap/lib/CardBody';

import WidgetBox from '@gqlapp/base/View/WidgetBox';
import Logo from "@xem/icon/header/logo.svg";
import FacebookButton from '@xem/icon/social/facebook';
import GoogleButton from '@xem/icon/social/google';
import RegisterForm from "./form/user/RegisterForm";
import {map} from "../helpers/config";
import Container from "reactstrap/lib/Container";
import View from "@gqlapp/base/View";
import RegisterStepTwo from "./form/user/RegisterFormTwo";
import RegisterStepThree from "./form/user/RegisterStepThree";
import Box from "@mui/material/Box";
import settings from '@xem/config'
export const RegisterView = (({ site: { name: sitename } = {}, isRegistered, signInWithGoogle, signInWithFacebook, values, values:{ level }, ...props }) => {

	const renderConfirmationModal = () => (
		<Card>
			<CardGroup style={{ textAlign: 'center' }}>
				<CardTitle>{'register.confirmationMsgTitle'.t()}</CardTitle>
				<CardText>{'register.confirmationMsgBody'.t()}</CardText>
			</CardGroup>
		</Card>
	);

	return (
		<View className={'view-anonymous d-flex justify-content-center align-items-center'}>
			<Container fluid className={'px-0 px-md-2'}>
				<>
					{ isRegistered && settings.auth.password.requireEmailConfirmation ? (
						renderConfirmationModal()
					) : (
						<Row className={'row-n row-md-m'}>
							<Col className={'d-flex justify-content-center align-items-center'}>
								<WidgetBox className={'widget-anonymous-form hidden animated pulse rounded-md-2 shadow-md bg-white'}>
									<Row className={'row-n'}>
										<Col xs={12} className={'order-md-2 order-1 d-flex justify-content-center'} style={{ width: '416px', maxWidth: '100%'}}>
											<>
												<CardBody className={'p-3'} style={{minHeight: (level ===2 )? '350px': '550px'}}>
													<Box sx={{
														width: '100%',
														'& .MuiFormControl-root': { marginTop: '8px', marginBottom: 0, minHeight: '62px'},
														'& .MuiFormHelperText-root': { fontSize: '12px', marginTop: '2px', lineHeight: '14px'},
														'& .phone-number .MuiFormControl-root, & .Mui-error .MuiFormControl-root':{
															minHeight: '40px'
														},
														'& .Mui-error':{
															'& .MuiOutlinedInput-notchedOutline':{
																borderColor: '#ff1744',
															},
															'& .MuiFormLabel-root, & .MuiFormHelperText-root':{
																color: '#ff1744',
															},
															'& .MuiFormHelperText-root':{
																lineHeight: '12px',
																margin: '4px 14px 0',
																fontSize: '10px'
															}
														}
													}}>
														<div className={'pb-0'}>
															<div
																className={'text-center d-flex justify-content-center align-items-center'}
																style={{
																	height: '50px',
																	width: '100%'
																}}>
																<Link href={'/'}><Logo height={'21px'} /></Link>
															</div>
														</div>
														<div
															className={'text-center d-flex justify-content-center align-items-center'}
															style={{
																height: '69px',
																width: '100%',
																paddingBottom: '30px'
															}}
														>
															{(!level)&&(<>
																<div className={'pb-1 text-h2 text-center'}>{'register.title'.t()}</div>
															</>)}

															{([1].includes(level)) && <>
																<div className={'pb-1 text-h2 text-center'}>{`user:account.phone.verify`.t()}</div>
															</>}


															{([2].includes(level)) && <>
																<div className={'pb-1 text-h2 text-center'}>{'user:account.phone.code'.t()}</div>
															</>}
														</div>
														{(level === 1) && (<>
															<div className={'pb-1'}>
																<div className={'pb-3 text-h5 text-center'}>
																	{'user:account.phone.note'.t()}
																</div>
															</div>
														</>)}

														{(level === 2)&&(<>
															<div className={'pb-3'}>
																<div className={'pb-3 text-h5 text-center'}>{'user:account.phone.notify'.t({ sitename })}</div>
															</div>
														</>)}

														{(!level)&&(<RegisterForm {...{...props, values }} />)}
														{(level === 1)&&(<RegisterStepTwo {...{...props, values }} />)}
														{(level === 2)&&(<RegisterStepThree {...{...props, values }} />)}
													</Box>
													{(!level)&&(<>
														<div className={'pt-2'}>
															<hr className={'hr-text my-2'} data-content={'user:account.register.or'.t()}/>
														</div>
														<Row medium>
															<Col><FacebookButton onClick={signInWithFacebook} /></Col>
															<Col><GoogleButton onClick={signInWithGoogle} /></Col>
														</Row>
														<div className={'py-2'}>
															<div className={'pb-3 text-center'}>
																{'user:account.existed'.t()}
																&nbsp;
																<Link href={map({ path: 'login' })} className={'text-orange'}>
																	{'user:account.login.label'.t()}
																</Link>
															</div>
														</div>
													</>)}

												</CardBody>
											</>
										</Col>

									</Row>
								</WidgetBox>
							</Col>
						</Row>
					)}
				</>
			</Container>
		</View>
	);
})

export default RegisterView;
